<script>
  import { crossfade, fly, fade } from "svelte/transition";
  import {
    makeSimpleWorker,
    makeStatefulWorker,
    terminateStatefulWorker
  } from "inline-webworker-functional/browser";
  import csv from "csvtojson";
  import { asteroid } from "@/meteor";
  import { mergeRows, translateValues } from "./processing.js";

  let reader = new FileReader();
  const [send, receive] = crossfade({});

  const STATE_START = "STATE_START";
  const STATE_SELECTED = "STATE_SELECTED";
  const STATE_PREPROCESSED = "STATE_PREPROCESSED";
  const STATE_UPLOADING = "STATE_UPLOADING";
  const STATE_DONE = "STATE_DONE";

  $: state = STATE_START;
  $: status = [];
  $: browserPct = 0;
  $: pct = (batchCursor / json.length) * 100;
  $: json = [];
  $: csvRows = null;
  $: batchCursor = 0;
  let encoding = "ISO-8859-1";
  let overwrite = false;

  let files = [];
  $: file = files[0];

  $: readFiles(files);

  reader.onload = async function() {
    const mergeRowsAsync = makeSimpleWorker(mergeRows);
    const translateValuesAsync = makeSimpleWorker(translateValues);

    try {
      const rawJson = await csv({ delimiter: ";" }).fromString(reader.result);
      csvRows = rawJson.length;

      browserPct = 50;
      const translatedJson = await translateValuesAsync(rawJson);

      browserPct = 75;
      json = await mergeRowsAsync(translatedJson);

      browserPct = 100;
      console.log(json);
      setTimeout(() => {
        state = STATE_PREPROCESSED;
      }, 1000);
    } catch (err) {
      console.error(err);
    }
  };

  function readFiles(files) {
    batchCursor = 0;
    browserPct = 0;
    if (files.length) {
      state = STATE_SELECTED;
      setTimeout(() => {
        browserPct = 25;
      });

      setTimeout(() => {
        reader.readAsText(files[0], "ISO-8859-1");
      }, 1000);
    }
  }

  async function upload() {
    state = STATE_UPLOADING;
    insertBatch([...json], 100);
  }

  async function insertBatch(batch, size, offset = 0) {
    const currentBatch = batch.splice(0, 100);
    const method = overwrite ? "products.batchUpsert" : "products.batchInsert";
    await asteroid.call(method, currentBatch);
    batchCursor = offset + currentBatch.length;
    if (batch.length) {
      setTimeout(() => {
        insertBatch(batch, size, offset + size);
      }, 0);
    } else {
      state = STATE_DONE;
    }
  }
</script>

<style>
  .pg-bar {
    transition: all 1s;
  }
</style>

<div class="absolute inset-0 overflow-hidden">
  <div    class="absolute bottom-0 left-0 z-10 p-12 font-bold text-gray-700">
    <div in:fly={{ x: -200 }}
    out:fly={{ x: -200 }}>
    <a href="/">← Tilbage</a>
    </div>

  </div>

  {#if state === STATE_START}
    <div
      class="absolute inset-0 flex content-center justify-center flex-wrap
      h-full text-center">
      <div in:fly={{ y: -500 }} out:fly={{ y: -500 }}>

        <div class="w-64 h-20 overflow-hidden relative shadow-lg flex">
          <button
            class="inset-0 w-full h-full bg-orange-400 text-white absolute
            text-2xl ">
            Åbn fil
          </button>
          <input
            type="file"
            bind:files
            class="h-full w-full opacity-0 cursor-pointer" />
        </div>
        <div class="bg-red-500 relative text-gray-400 font-bold ">
          <input
            type="text"
            bind:value={encoding}
            class="w-full absolute left-0 text-center mt-16 bg-transparent
            focus:text-gray-600 outline-none" />
        </div>

      </div>
    </div>
  {:else if state === STATE_SELECTED}
    <div class="absolute inset-0 flex content-center justify-center flex-wrap">
      <div class="w-1/2" in:fly={{ y: 500 }} out:fly={{ y: -500 }}>
        <div class="text-center text-3xl pb-6">Forbehandling</div>
        <ul class="flex justify-between ">
          <li>Indlæser</li>
          <li>Konverterer</li>
          <li>Normaliserer</li>
          <li>Fletter</li>
          <li>Færdig</li>
        </ul>
        <div class="bg-red-200 w-full h-10 shadow relative">
          <div
            class="absolute inset-y-0 left-0 bg-red-500 pg-bar "
            style={'right: ' + (100 - browserPct) + '%'} />
        </div>

      </div>
    </div>
  {:else if state === STATE_PREPROCESSED}
    <div class="absolute inset-0 flex content-center justify-center flex-wrap">
      <div class="text-center" in:fly={{ y: 500 }}>
        <div out:fade>
          <div class="text-2xl">Fandt {json.length} produkter</div>
          <div class="py-10">
            <input type="checkbox" bind:checked={overwrite} id="overwrite" />
            <label for="overwrite">
              <strong class="pl-3 text-gray-600">
                Overskriv eksisterende produkter
              </strong>
            </label>
          </div>
        </div>
        <div
          class="w-64 h-20 overflow-hidden relative shadow-lg inline-block"
          in:receive={{ key: 'uploadBox' }}
          out:send={{ key: 'uploadBox' }}>
          <button
            on:click={upload}
            class="inset-0 w-64 h-full bg-orange-400 text-white absolute
            text-2xl ">
            Tilføj produkter
          </button>
        </div>
        <div>
          <button on:click={() => (state = STATE_START)}>
            Vælg en anden fil
          </button>
        </div>
      </div>
    </div>
  {:else if state === STATE_UPLOADING}
    <div class="absolute inset-0 flex content-center justify-center flex-wrap">
      <div class="w-1/2 text-center">
        <div class="text-2xl pb-2">
          Uploader {batchCursor} af {json.length} produkter ({Math.round(pct)}%)
        </div>
        <div
          class="bg-red-200 w-full h-20 shadow relative"
          in:receive={{ key: 'uploadBox' }}
          out:send={{ key: 'uploadBox' }}>
          <div
            class="absolute inset-y-0 left-0 bg-red-500 pg-bar "
            style={'right: ' + (100 - pct) + '%'} />
        </div>
      </div>
    </div>
  {:else if state === STATE_DONE}
    <div
      class="absolute inset-0 flex content-center justify-center flex-wrap"
      out:fly={{ y: 500 }}>
      <div
        class="w-1/2 h-64 content-center flex flex-wrap justify-center
        text-center bg-green-600 shadow-2xl rounded-lg"
        in:receive={{ key: 'uploadBox' }}>
        <div>
          <div class="text-center font-bold text-5xl text-white">Færdig</div>
          <div class="text-green-100 text-xl">
            Indlæste {batchCursor} produkter
          </div>
          <div class="text-white">
            <button on:click={() => (state = STATE_START)}>
              Upload flere filer
            </button>
          </div>
        </div>
      </div>
    </div>
  {/if}

</div>
